import { Dayjs } from "dayjs";
import { EnableablePreference } from "./EnableablePreference";

export enum ExperienceOptionDisplayType {
    HIGHLIGHTED = "highlighted",
    STANDARD = "standard",
}

// Embedded on Experience.optionsPreference.options - no owner reference, no separate collection.
export interface ExperienceOption {
    id: ID;
    name: string;
    content: string;
    displayType: ExperienceOptionDisplayType;
    deletedAt?: Dayjs;
    createdAt?: Dayjs;
    updatedAt?: Dayjs;
}

export interface ExperienceOptionPreference extends EnableablePreference {
    options: ExperienceOption[];
}

export interface ScheduleOption {
    id?: ID;
    // "" marks an attachment whose Option has not been chosen yet.
    optionId?: ID;
    priority: number;
    createdAt?: Dayjs;
    updatedAt?: Dayjs;
}

// SCHEDULE: copied from the matching Schedule when the Event is created.
// EVENT: set or turned off by an explicit seller action on this one Event.
export enum EventOptionSource {
    SCHEDULE = "schedule",
    EVENT = "event",
}

export interface EventOption {
    id?: ID;
    optionId: ID;
    source: EventOptionSource;
    // Set when a seller turned this Option off on the Event; the row stays so its Schedule can't bring it back.
    deletedAt?: Dayjs;
    createdAt?: Dayjs;
    updatedAt?: Dayjs;
}
